<template>
    <div class="no-results">
        <slot name="image">
            <no-results-img />
        </slot>
        <span class="title no-results__text">
            <slot>
                {{ text }}
            </slot>
        </span>
    </div>
</template>

<script>
import NoResultsImg from "@/Shared/ImagesSVG/NoResultsImg.vue";

export default {
    components: {NoResultsImg},
    props: {
        text: {
            type: String,
            default: "No records to be shown"
        }
    }
}
</script>
